import { makeStyles } from '@material-ui/core/styles'

export const newBrunswickDiningStyle = makeStyles((theme) => ({
  root: {
    width: '100%',
    height: 440,
    overflowY: 'auto',
  },
  rootNotes: {
    width: '100%',
    height: 400,
    overflowY: 'auto',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    // fontWeight: theme.typography.fontWeightRegular,
  },
  img: {
    width: '100%',
    height: 90,
  },
  accordianDetails: {
    display: 'flex',
    flexDirection: 'column',
  },
  diningCard: {
    width: '95%',
    borderRadius: '1rem',
    margin: '0 auto 10px auto',
    '&:hover': {
      cursor: 'pointer',
    },
    '&:focus-visible': {
      outline: `1px solid ${theme.palette.button.focusBorder}`,
      boxShadow: `0 0 0 3px ${theme.palette.button.focusOutline}`,
      // backgroundColor: theme.palette.button.hover,
      // borderRadius: '4px',
    },
  },
  menuButtonsSection: {
    display: 'flex',
    justifyContent: 'space-evenly',
    paddingTop: 10,
    paddingBottom: 10,
  },
  menuButtonBase: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '2px',
    width: '100px',
    '&:focus-visible': {
      outline: `1px solid ${theme.palette.button.focusBorder}`,
      boxShadow: `0 0 0 3px ${theme.palette.button.focusOutline}`,
      backgroundColor: theme.palette.button.hover,
      borderRadius: '4px',
    },
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: theme.palette.button.hover,
      borderRadius: '4px',
    },
  },
}))
